export default "__VITE_ASSET__d53dabdf__$_?component__"